/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespDetailsTabs_item = {
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_sku">;
    } | null> | null;
    readonly storyTellingModule: {
        readonly tabs: ReadonlyArray<{
            readonly tabType: string;
            readonly tabTitle: string;
            readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
        } | null> | null;
    } | null;
    readonly seller: {
        readonly isAccessible: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespAboutModule_item" | "PdpRespDealerDetails_item">;
    readonly " $refType": "PdpRespDetailsTabs_item";
};
export type PdpRespDetailsTabs_item$data = PdpRespDetailsTabs_item;
export type PdpRespDetailsTabs_item$key = {
    readonly " $data"?: PdpRespDetailsTabs_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetailsTabs_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailsTabs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetails_sku"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespStorytellingTab_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '169e659d65d3f2b963d3fc388a86f0a2';
export default node;
